import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Lazy } from "swiper";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/lazy";
import "swiper/css/controller";
import "swiper/css/effect-fade";

import InfluencersCircles from "../../components/InfluencersCircles";
import productImage1 from "../../assets/images/boxImage.png";
import Container from "../../components/Container";
import HeyThereSection from "../../components/HeyThereSection";
import Box from "./Box";

const images = [productImage1, productImage1, productImage1];

const GepzoBox = () => {
  const swiperProps = {
    modules: [EffectFade, Lazy, Autoplay],
    lazy: true,
    effect: "flip",
    preloadImages: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
    autoPlay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  };

  return (
    <>
      <section className="boxes pt-12 bg-white relative after:content-[''] after:bg-[#e6e6e6] after:h-24 after:block after:w-full after:absolute after:bottom-0">
        <Container maxWidth={"max-w-[1400px]"} width={"w-[95%]"}>
          <div className="">
            <div className="title font-medium text-[23px] flex justify-center">
              <h2>Select your Gepzo Box Subscription</h2>
            </div>
            <Swiper {...swiperProps} className="w-full">
              {images.map((slide, index) => {
                return (
                  <SwiperSlide key={index}>
                    <Box imageSrc={slide} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </Container>
      </section>

      <section className="influencers bg-[#e6e6e6]">
        <Container>
          <InfluencersCircles />
        </Container>
      </section>

      <section className="hey-there flex justify-center py-12 bg-white">
        <Container display={"flex justify-center"}>
          <HeyThereSection />
        </Container>
      </section>
    </>
  );
};

export default GepzoBox;
